import * as S from "effect-app/Schema"

export const MAX_AI_CHAT_MESSAGE = 2000
export const MAX_AI_CHAT_HISTORY = 20

export class AiChatTurn extends S.Opaque<AiChatTurn, AiChatTurn.Encoded>()(
  S
    .Struct({
      role: S.Literals(["user", "assistant"]),
      text: S.String.pipe(S.check(S.isBetweenLength(1, MAX_AI_CHAT_MESSAGE)))
    })
    .annotate({ identifier: "AiChatTurn" })
) {}

export const AiChatInput = S.Struct({
  message: S.String.pipe(S.check(S.isBetweenLength(1, MAX_AI_CHAT_MESSAGE))),
  history: S.Array(AiChatTurn).pipe(S.check(S.isBetweenLength(0, MAX_AI_CHAT_HISTORY)))
})

// codegen:start {preset: model}
//
export namespace AiChatTurn {
  export interface Encoded extends S.StructNestedEncoded<typeof AiChatTurn> {}
}
//
// codegen:end
